import React,{useState,useEffect} from 'react'
import axios from 'axios';
import Header from '../Header';
import Sidebar from '../Sidebar';
import { DatePicker,message } from 'antd';
import AddHeader from '../AddHeader';

function AddHoliday() {

    const [sidebarOpen, setSidebarOpen] = useState(false);
  
    const [showModal, setShowModal] = useState(false);

  
     const [reason, setReason] = useState();
     const [startDate, setStartdate] = useState(null);
     const [endDate, setEnddate] = useState(null);
     const [status, setStatus] = useState(true);
  

  
    const AddCoupons = (e) => {
      e.preventDefault();
      
      var axios = require("axios");
     
               if (!reason || !startDate || startDate === null  || !endDate || endDate === null || status === "") {
                 message.error("All fields must be filled correctly.");
                 return;
             }
     
             const data = {
                 reason,
                 startdate: startDate.format('YYYY-MM-DD'),
                 enddate: endDate.format('YYYY-MM-DD'),
                 status: status
             };

             console.log("data --------------> ", data)
  
      var config = {
        method: "post",
        url: "https://adminapi.youjifresh.com/holidays",
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("youji_token"),
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          message.success("Holidays Added");
          setTimeout(() => {
            window.location.reload()
          }, 500);
        })
        .catch(function (error) {
          console.log(error);
          message.error(error.response.data.message);
        });
      setShowModal(false);

    
    };
  
    const clearForm = () => {
setStartdate(null);
setEnddate(null);
setStatus(true);
setReason("")
    };
  
    
    return (
        <>
          <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}
        <AddHeader sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main>
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Page header */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
              {/* Left: Title */}
              <div className="mb-4 sm:mb-0">
                <h1 className="text-2xl p-6 md:text-3xl text-gray-800 font-bold">
                  Add Holiday
                </h1>
              </div>

              {/* Right: Actions */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                {/* Delete button */}
               
                {/* Dropdown */}
                {/* <DateSelect /> */}
                {/* Filter button */}

                {/* Add customer button */}
              
              </div>
            </div>
         

            {/* Table */}
                                <div className="relative px-4 flex-auto">
                                            <form id="form_add_Coupon">
                                              <div class="flex flex-wrap -mx-2 mb-2">
                                                
                                              <div class="w-full md:w-1/2 p-2 mb-6 md:mb-0">
                                                  <label
                                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                                    for="form__coupon_code"
                                                  >
                                                    Reason
                                                  </label>
                                                  
                                                  <input
                                                    class="appearance-none block text-clip resize-y overflow-hidden w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    id="form__coupon_code"
                                                    type="text"
                                                    value={reason}
                                                    onChange={(e) => {
                                                   
                                                      setReason(e.target.value)
                                                    }}
                                                    placeholder="Reason"
                                                  />
                                                </div>
                    
                                                <div class="w-full md:w-1/2 p-2 mb-6 md:mb-0">
                                                  <label
                                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                                    for="form__coupon_active"
                                                  >
                                                    Status
                                                  </label>
                                                  <div className='relative'>
                                                <select
                                                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                      id="form__coupon_active"
                                                      value={status}
                                                      onChange={(e) => {
                                                        
                                                        setStatus(e.target.value)
                                                      }}
                                                    >
                                                      <option value={status} selected>{status===true?'True':"false"}</option>
                                                      <option value={true} hidden={status===true}>True</option>
                                                      <option value={false} hidden={status===false}>False</option>         
                                                      
                                                      
                                                    </select>
                                                    </div>
                                                </div>
                    
                    
                                               
                                               
                                              
                    
                                                <div class="w-full md:w-1/2 p-2 mb-5 mt-2 md:mb-0">
                                                  <label
                                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                                    for="form__coupon_exp_date"
                                                  >
                                                    Start Date
                                                  </label>
                                                  <div class="relative">
                                                  
                                                    <DatePicker
                                                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                      id="form__coupon_exp_date"
                                                      isclearable
                                                      value={startDate}
                                                      onChange={(date) => {
                                                        
                                                        setStartdate(date)
                                                        
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                                <div class="w-full md:w-1/2 p-2 mb-5 mt-2 md:mb-0">
                                                  <label
                                                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                                                    for="form__coupon_exp_date"
                                                  >
                                                    End Date
                                                  </label>
                                                  <div class="relative">
                                                  
                                                    <DatePicker
                                                      class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-3 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                      id="form__coupon_exp_date"
                                                      isclearable
                                                      value={endDate}
                                                      onChange={(date) => {
                                                        
                                                        setEnddate(date)
                                                        
                                                      }}
                                                    />
                                                  </div>
                                                </div>
                                               
                                              </div>
                                            </form>
                                          </div>
                      {/*footer*/}
                      <div className="flex items-center  p-6 border-t border-solid border-blueGray-200 rounded-b">
                        <button
                          onClick={clearForm}
                          className=" btn  content-start bg-gray-400 hover:bg-gray-600 text-white mr-2"
                        >
                          <span className="hidden xs:block">Clear</span>
                        </button>
                        <div className="justify-items-end ">
                         
                          <button
                            className="btn bg-yellow-500 hover:bg-yellow-600 text-white"
                            onClick={AddCoupons}
                          >
                            <span className="hidden xs:block">
                              Add
                            </span>
                          </button>
                        </div>
                      </div>

            {/* Pagination */}
            
          </div>
        </main>
      </div>
    </div>
        </>
    )
}

export default AddHoliday
